import React, { useState, useEffect } from 'react';
import Globals from '../Globals';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { doc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { db } from "../firebase";
import { Row, Col, Container, Toast } from 'react-bootstrap';
import ToggleCheckboxImage from '../Components/ToggleCheckboxImage';
const EditPlayer = ({setCurrentTask, currentTask, setPlayers, players, teamName, selectedPlayerName}) => {
    const [errorEditing, setErrorEditing] = useState(false);
    const [newPlayerName, setNewPlayerName] = useState(selectedPlayerName);
    const [playerEmail, setPlayerEmail] = useState('');
    const [isStaff, setIsStaff] = useState(false);
    const [rulesResults, setRulesResults] = useState([]);
    
    function followsEditPlayerRules(playerNameToTest) {
        const results = [];
        const playerNameToTestLowerCase = playerNameToTest.toLowerCase();
        const selectedPlayerLowerCase = selectedPlayerName.toLowerCase();
        //Rule #1: Player can't have the same name as another player (except themselves)
        results.push(!players.some(v => v.name.toLowerCase() === playerNameToTestLowerCase && v.name.toLowerCase() !== selectedPlayerLowerCase))
        //Rule #2: Player name can't exceed 20 characters
        results.push(!(playerNameToTest.length > 20))
        //Rule #3: Player name can only have letters and spaces
        results.push((playerNameToTest.match(/[a-zA-Z ]/g)?.length === playerNameToTest.length))
        return results;
    }
    
    // Initialize/update state when modal opens or player changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (currentTask === Globals.taskNumbers.edit && selectedPlayerName) {
            const selectedPlayer = players.find(v => v.name === selectedPlayerName) || {};
            setNewPlayerName(selectedPlayerName);
            setPlayerEmail(selectedPlayer.email || '');
            setIsStaff(selectedPlayer.isStaff || false);
            setRulesResults(followsEditPlayerRules(selectedPlayerName));
        }
    }, [selectedPlayerName, currentTask, players]);
    const rulesStrings = [
        "Must be unique.",
        "20 characters or less.",
        "Only contains letters & spaces."
    ]
    
    const updateRules = (value) => {
        setErrorEditing(false);
        setNewPlayerName(value);
        setRulesResults(followsEditPlayerRules(value));
    }

    const editPlayerInRoster = async (e) => {
        e.preventDefault();
        if(rulesResults.some(v => !v)){
            setErrorEditing(true);
        }else{
            const docRef = doc(db, "teams", teamName);
            const playerInfo = players.filter(v => v.name === selectedPlayerName)[0];
            const oldEmail = playerInfo.email;
            const newEmail = playerEmail;
            
            // Update player info
            playerInfo.name = newPlayerName;
            playerInfo.email = newEmail;
            playerInfo.isStaff = isStaff;
            
            console.log('playerInfo :', playerInfo);
            setPlayers(players.sort((a,b) => a.name > b.name ? 1 : -1));
            
            //try to update the player info in the roster, if it fails, show error toast and keep modal open
            let updateSuccessful = false;
            try {
                await updateDoc(docRef, {
                    players: arrayUnion({...playerInfo})
                });
                await updateDoc(docRef, {
                    players: arrayRemove({...playerInfo, name: selectedPlayerName, email: oldEmail})
                });
                updateSuccessful = true;
            } catch (err) {
                console.error('Failed to edit player info', err);
                setErrorEditing(true);
            }
            if (!updateSuccessful) {
                return;
            }

            // Update authorizedEmails if email changed
            if (oldEmail !== newEmail) {
                if (oldEmail) {
                    await updateDoc(docRef, {
                        authorizedEmails: arrayRemove(oldEmail)
                    });
                }
                await updateDoc(docRef, {
                    authorizedEmails: arrayUnion(newEmail)
                });
            }
            
            setCurrentTask(Globals.taskNumbers.none);
        }
    }

    return (
        <Modal show={currentTask === Globals.taskNumbers.edit} onHide={() => setCurrentTask(Globals.taskNumbers.none)}>
            <Form onSubmit={editPlayerInRoster}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Player: {selectedPlayerName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="inputPlayerName">Name</Form.Label>
                        <Form.Control
                            type="name"
                            id="inputPlayerName"
                            value={newPlayerName}
                            onChange={(e) => updateRules(e.currentTarget.value)}
                            aria-describedby="nameHelp"
                        />
                        <Container>
                            {rulesStrings.map((rule, i) => (
                                    <Row key={`${rulesResults[i]}_${i}`}>
                                        <Col>
                                            <Form.Text id="nameHelp" muted>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className={`svgToSwap-${i} bi bi-x-lg`} viewBox="0 0 16 16">
                                                    <ToggleCheckboxImage booleanValue={rulesResults[i]} idx={i}/>
                                                </svg>
                                                {rule}
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                )
                            )}
                        </Container>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="playerEmail">Email Address</Form.Label>
                        <Form.Control
                            type="email"
                            id="playerEmail"
                            value={playerEmail}
                            onChange={(e) => setPlayerEmail(e.currentTarget.value)}
                            required
                        />
                    </Form.Group>

                    <InputGroup className="mb-3">
                        <InputGroup.Text>Is Staff</InputGroup.Text>
                        <div className="input-group-append" style={{flex: 1, display: 'flex', alignItems: 'center', paddingLeft: '10px'}}>
                            <ToggleButton
                                id="isStaff"
                                type="checkbox"
                                variant="secondary"
                                checked={isStaff}
                                value={0}
                                onChange={ () => setIsStaff(!isStaff) }
                                >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="svgToSwap bi bi-x-lg" viewBox="0 0 16 16">
                                    <ToggleCheckboxImage booleanValue={isStaff}/>
                                </svg>      
                            </ToggleButton>
                        </div>
                    </InputGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" type='submit'>
                        Save Edit
                    </Button>
                    <Button variant="secondary" onClick={() => setCurrentTask(Globals.taskNumbers.none)}>
                        Cancel
                    </Button>
                </Modal.Footer>                 
            </Form>
            <div className="toast-container position-fixed bottom-0 end-0 p-3">
                <Toast show={errorEditing} onClose={() => setErrorEditing(!errorEditing)} delay={3000} autohide bg={'warning'}>
                    <Toast.Body>Player's information not changed.</Toast.Body>
                </Toast>
            </div>
        </Modal>
    )
}

export default EditPlayer;
